import { render, staticRenderFns } from "./ticTacToe2.vue?vue&type=template&id=27970c9f&"
import script from "./ticTacToe2.vue?vue&type=script&lang=js&"
export * from "./ticTacToe2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports